// @flow
import React from 'react';
import {Helmet} from 'react-helmet';

type TProps = {
    children: React$Node,
};
/**
 * Компонент изменения заголовка
 * @param children название страницы
 * @return {*} компонент заголовка
 * @constructor
 */
export const HelmetTitle = ({children}: TProps) => {
    return <Helmet titleTemplate="%s - CITO">{children}</Helmet>;
};
